import { useTranslation } from "react-i18next";
import { Controller, useFormContext } from "react-hook-form";
import { FormControl, FormLabel, Select, MenuItem, FormHelperText } from "@mui/material";

import { entityLevels } from "../../../../../../Entity/enums/entity-level";
import { EditEntityProfileData } from "../../../../../types/editEntityProfile-type";

const EntityLevelField = () => {
  const { t } = useTranslation("profiles", { keyPrefix: "entityProfileEdit" });
  const { t: tEntity } = useTranslation("entity");
  const { control } = useFormContext<EditEntityProfileData>();

  return (
    <Controller
      name="level"
      control={control}
      render={({ field, fieldState: { error } }) => (
        <FormControl error={!!error} fullWidth>
          <FormLabel
            sx={{
              color: "var(--Dark---800, #414141)",
              fontFamily: "Montserrat",
              fontSize: "14px",
              fontStyle: "normal",
              fontWeight: 600,
              lineHeight: "24px",
            }}
          >
            {t("entityLevel")}
          </FormLabel>
          <Select key={field.value} {...field} displayEmpty value={field.value ?? ""}>
            <MenuItem value="" disabled>
              {t("selectEntityLevel")}
            </MenuItem>
            {entityLevels.map((level) => (
              <MenuItem key={level} value={level}>
                {tEntity(`entityLevel.${level}`)}
              </MenuItem>
            ))}
          </Select>
          {error?.message && <FormHelperText sx={{ color: "#CC3E3E" }}>{t(error.message)}</FormHelperText>}
        </FormControl>
      )}
    />
  );
};

export default EntityLevelField;
